export const data = [
  {
    name: "Edmond Rostand",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Edmond_Rostand_en_habit_vert_01.jpg/300px-Edmond_Rostand_en_habit_vert_01.jpg",
    statistics: [
      "Author",
      "01 April 1868",
      "France",
    ],
  },
  {
    name: "Gérard Depardieu",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/G%C3%A9rard_Depardieu_avp_2016_2.jpg/390px-G%C3%A9rard_Depardieu_avp_2016_2.jpg",
    statistics: [
      "Cyrano de Bergerac",
      "27 December1948",
      "France",
    ],
  },
  {
    name: "Anne Brochet",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Anne_Brochet_Cannes.jpg/330px-Anne_Brochet_Cannes.jpg",
    statistics: [
      "Roxana",
      "22 November 1966",
      "France",
    ],
  },
  {
    name: "Vincent Perez",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Vincent_Perez_Cannes_2017.jpg/330px-Vincent_Perez_Cannes_2017.jpg",
    statistics: [
      "Baron Christian",
      "10 June 1964",
      "Switzerland",
    ],
  },
  {
    name: "Philippe Morier-Genoud",
    img: "https://turkcealtyazi.org/film/nmbig/nm0605429.jpg",
    statistics: [
      "Le Bret",
      "2 March 1944",
      "France",
    ],
  },
  {
    name: "Philippe Volter",
    img: "https://img02.imgsinemalar.com/images/afis_buyuk/p/philippe-volter-1469006317.jpg",
    statistics: [
      "Viscount of Valvert",
      "23 March 1959",
      "France",
    ],
  },
  {
    name: "Sandrine Kiberlain",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Sandrine_Kiberlain_Deauville_2018.jpg/330px-Sandrine_Kiberlain_Deauville_2018.jpg",
    statistics: [
      "Sister Colette",
      "25 February 1968 ",
      "France",
    ],
  },
  {
    name: "Roland Bertin",
    img: "https://tr.web.img2.acsta.net/c_310_420/medias/nmedia/18/60/00/30/20512411.jpg",
    statistics: [
      "Ragueneau",
      "16 November 1930",
      "France",
    ],
  },
];
